<template>
    <div class="board-list">
        <!-- 详情页—— 带复选框 -->
        <el-checkbox-group :disabled="!isShowCheckbox" :class="isShowCheckbox ? 'show-checkbox' : ''" v-model="checkedBoard"
            v-if="type === 'detail'" :max="listData.length - 1">
            <el-checkbox v-for="(item, index) in listData" :label="item.name" :key="item.id">
                <div :class="['board', type === 'detail' ? 'board-detail' : '']">
                    <div class="board-img" @click="toDetail(item, index)">
                        <el-image :fit="'cover'" :src="item.board_url"
                            :preview-src-list="getPreviewImages(index)"></el-image>
                        <i v-if="user_cate == 1" class="iconfont icon-tianxie" @click.stop="editName(item)"></i>
                    </div>
                    <slot :data="item"></slot>
                </div>
            </el-checkbox>
        </el-checkbox-group>
        <template v-else>
            <!-- 列表页 -->
            <div v-for="item in listData" :key="item.id" :class="['board', type === 'detail' ? 'board-detail' : '']">
                <div class="board-img" @click="toDetail(item)">
                    <el-image :fit="'cover'" :src="item.board_url"></el-image>
                    <i v-if="user_cate == 1" class="iconfont icon-tianxie" @click.stop="editName(item)"></i>
                </div>
                <slot :data="item"></slot>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        listData: {
            type: Array,
            default: []
        },
        src_list: {
            type: Array,
        },
        type: {
            type: String,
            default: ''
        },
        isShowCheckbox: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            checkedBoard: [],
        }
    },
    computed: {
        user_cate () {
            return localStorage.getItem('cate')
        },
    },
    methods: {
        editName (item) {
            const { id, name, alias_name, board_url } = item
            const data = { id, name, alias_name, board_url }
            this.$emit('editName', data)
        },
        toDetail (item, index) {
            if (this.type === 'detail') {
                return false
            }
            const { id } = item
            this.$router.push('/banshu/details?id=' + id)
        },
        // 按顺序预览图片
        getPreviewImages (index) {
            if (this.isShowCheckbox) {
                return []
            }
            let imgs = [...this.src_list]
            if (index === 0) return imgs
            let start = imgs.splice(index)
            let remain = imgs.splice(0, index)
            return start.concat(remain)
        }
    }

}
</script>

<style lang="scss" scoped>
.board-list {
    display: flex;
    flex-wrap: wrap;

    // 复选框
    /deep/ .el-checkbox {
        position: relative;
        margin-right: 0;

        .el-checkbox__input {
            position: absolute;
            left: 25px;
            top: 10px;
            display: none;
        }

    }

    // 显示复选框
    .show-checkbox {
        /deep/ .el-checkbox__input {
            display: block;
        }
    }

    .board {
        margin: 0 15px 15px 0;
        padding: 12px;
        box-sizing: border-box;
        border-radius: 8px;
        background: #fff;


        &:hover {
            box-shadow: 0 10px 24px 0 #d8e2eb;
        }


        .board-img {
            position: relative;

            .icon-tianxie {
                display: none;
                position: absolute;
                top: 12px;
                right: 12px;
                font-size: 16px;
                color: #fff;
                cursor: pointer;
            }

            &:hover>.icon-tianxie {
                display: block;
            }
        }

        .el-image {
            width: 283px;
            height: 173px;
        }
    }

    .board-detail {
        padding: 0;
        display: block;

        .board-img {
            .el-image {
                border-radius: 8px 8px 0 0;
            }

        }

    }

    .board-describe {
        overflow: hidden;

        .board-name {
            margin: 12px 0;
            font-size: 16px;
            color: #333;
            font-weight: bold;
        }

        .board-date {

            font-size: 14px;
            color: #7C8184;

            .board-count {
                float: right;


                img {
                    margin-top: -2px;
                    vertical-align: middle;
                }
            }
        }


    }

}

/deep/ .el-checkbox__inner::after {
    height: 15px;
    left: 8px;
}

/deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
    background: #e6a23c;
    border-color: #e6a23c;
}

/deep/ .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #e6a23c;
}

/deep/ .el-checkbox__inner {
    border-radius: 50%;
    width: 20px;
    height: 20px;
}

/deep/ .el-checkbox__inner:hover {
    border-color: #e6a23c;
}
</style>


// WEBPACK FOOTER //
// src/view/Panel/banshu/components/Board.vue